// Import all components
import Button from './button'
import Calendar from './calendar'
import InputNumber from './input-number'
import Checkbox from './checkbox'
import { Form, FormItem } from './form'
import Icon from './icon'
import Input from './input'
import { Radio, RadioButton, RadioGroup } from './radio'
import Tree from './tree'
import Upload from './upload'
import VirtualList from './virtual-list'
import VirtualScrollList from './virtual-scroll-list'
import Empty from './empty'
import Paginations from './paginations'
import Tooltip from './tooltip'
import Switchs from './switchs'
import Slider from './slider'
import Progress from './progress'
import Cascaders from './cascaders'
import { Tabs, TabPane } from './tabs'

// Export all components
export {
  Button,
  Calendar,
  InputNumber,
  Checkbox,
  Form,
  FormItem,
  Icon,
  Input,
  Radio,
  RadioButton,
  RadioGroup,
  Tree,
  Upload,
  VirtualList,
  VirtualScrollList,
  Empty,
  Paginations,
  Tooltip,
  Switchs,
  Slider,
  Progress,
  Tabs,
  TabPane,
  Cascaders
}

// Vue plugin
import type { App } from 'vue'

const components = [
  Button,
  Calendar,
  InputNumber,
  Checkbox,
  Form,
  FormItem,
  Icon,
  Input,
  Radio,
  RadioButton,
  RadioGroup,
  Tree,
  Upload,
  VirtualList,
  VirtualScrollList,
  Empty,
  Paginations,
  Tooltip,
  Switchs,
  Slider,
  Progress,
  Tabs,
  TabPane,
  Cascaders
]

export default {
  install(app: App) {
    components.forEach(component => {
      if (component.name) {
        app.component(component.name, component)
      }
    })
    return app
  }
}
